<template>
    <v-card flat tile>
        <SwitchCategoryDialog :show="showSwitchDialog" :keywords="selectedRows" @close="showSwitchDialog = false" @catUpdated="catUpdated"></SwitchCategoryDialog>
        <DeleteDialog :deleteDialog="deleteDialog" :selectedDeleteItem="''" :deleteLabel="deleteLabel" :loading="deleteLoading" @delete="deleteKeywords" @close="deleteDialog = false"></DeleteDialog>
        <ConfirmDialog
            :confirmDialog="confirmDialog"
            :selectedItem="''"
            :label="confirmLabel"
            :loading="confirmLoading"
            @confirm="removeKeywordsCategory"
            @close="confirmDialog = false"></ConfirmDialog>
        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <v-chip outlined small class="mr-2 pl-4 pr-1">
                        {{ selectedRows.length }} SELECTED
                        <v-btn class="mx-1" x-small icon @click="selectedRows = []"><v-icon x-small>mdi-close</v-icon></v-btn>
                    </v-chip>
                    <v-divider vertical></v-divider>
                    <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2" color="primary" outlined rounded small class="mr-2" @click="showSwitchDialog = true">
                        <v-icon class="mr-1" small>mdi-swap-horizontal</v-icon>category</v-btn
                    >
                    <v-btn
                        v-if="selectedRows.filter((x) => x.category_id).length > 0"
                        elevation="0"
                        :disabled="$store.state.monitoring_suite_group.id == 2"
                        color="warning"
                        outlined
                        rounded
                        small
                        class="mr-2"
                        @click="confirmDialog = true">
                        <v-icon class="mr-1" small>mdi-tag-remove</v-icon>category</v-btn
                    >
                    <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2" outlined rounded color="error" small @click="deleteDialog = true">
                        <v-icon class="mr-1" small>mdi-delete</v-icon> delete</v-btn
                    >
                </div>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="!selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <v-btn :disabled="$store.state.monitoring_suite_group.id == 2" elevation="0" color="primary" outlined rounded small @click="$emit('showAddKwDialog')">
                        <v-icon class="mr-1" small>mdi-cloud-upload</v-icon>keywords</v-btn
                    >
                </div>
                <div style="position: absolute; z-index: 5; top: -38px; right: 150px">
                    <v-btn :disabled="$store.state.monitoring_suite_group.id == 2" elevation="0" color="primary" outlined rounded small @click="showCategorySwitchDialog">
                        <v-icon class="mr-1" small>mdi-swap-horizontal</v-icon>category</v-btn
                    >
                </div>
                <div style="position: absolute; z-index: 5; top: -38px; right: 275px">
                    <filter-menu :fields="filterFields" @filtersUpdated="filtersUpdated" :dense="true"></filter-menu>
                </div>
            </div>
        </v-slide-x-reverse-transition>

        <v-data-table
            :headers="headers"
            :items="rankings"
            :loading="loading"
            :sort-desc.sync="sortDesc"
            :sort-by.sync="sortBy"
            :page.sync="page"
            :search.sync="search"
            :items-per-page.sync="itemsPerPage"
            :server-items-length="count"
            :multi-sort="false"
            :footer-props="footerProps"
            @update:options="fetchData"
            fixed-header
            v-model="selectedRows"
            @click:row="onRowClick"
            item-key="_id"
            height="70vh"
            id="rankingstable"
            class="elevation-0">
            <!-- header slot -->
            <template v-for="(header_entry, index) in headers" v-slot:[`header.${header_entry.value}`]="{ header }">
                <span :key="index">
                    <span v-bind:style="{ width: header.width }">
                        <!-- Adding tooltips to header -->
                        <v-tooltip max-width="250" top :disabled="header.tooltip ? false : true">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" style="white-space: nowrap; text-transform: uppercase; font-weight: 500">
                                    {{ header.text }}
                                    <v-icon class="questionIcon" v-if="header.tooltip" x-small>mdi-help-circle-outline</v-icon>
                                </span>
                            </template>
                            <span>
                                <v-row no-gutters class="mb-2">
                                    <div cols="12"><v-icon color="white">mdi-help-circle-outline</v-icon></div>
                                </v-row>

                                <div v-if="header.value.substring(0, 8) == 'ranking_'">
                                    <div class="mt-2">
                                        <span
                                            ><b> Google Ranking for {{ header.text }}:</b>
                                        </span>
                                    </div>
                                    {{ header.tooltip }}
                                    <div class="mt-2">
                                        <span><b> Colorcodes:</b> </span>
                                    </div>
                                    <span v-for="(color, index) in positionColors2" :key="index">
                                        <v-chip x-small class="mr-1 mb-1 mt-1" :color="color">{{ (index == 0 ? index : index * 10) + " - " + (index + 1) * 10 }}</v-chip>
                                    </span>
                                </div>

                                <div v-else>{{ header.tooltip }}</div>
                            </span>
                        </v-tooltip>
                    </span>
                </span>
            </template>
            <template v-slot:item.keyword="{ item }">
                <div class="py-2" style="padding-left: -5px !important">
                    <span class="rtd pl-2">{{ item.keyword }}</span> <br />
                    <div style="white-space: nowrap" v-if="item.category_id">
                        <v-btn icon x-small @click="showAllCatsInTable"
                            ><v-icon x-small>{{ showAllCategories ? "mdi-chevron-right" : "mdi-chevron-left" }}</v-icon></v-btn
                        >
                        <span v-if="item.category_id && showAllCategories" style="white-space: nowrap">
                            <span v-for="(cat, index) in item.category_id.split(';')" :key="cat">
                                <v-icon v-if="index" x-small class="px-0">mdi-chevron-right</v-icon>
                                <v-chip x-small @click="setCat(item, index)"> {{ cat }}</v-chip>
                            </span>
                        </span>
                        <span v-else>
                            <v-chip x-small @click="setCategory(item)"> {{ item.category_id.split(";")[item.category_id.split(";").length - 1] }}</v-chip>
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:item.avg_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary" style="">
                    {{ $helpers.formatNumber(item.avg_search_volume) }}
                </v-chip>
            </template>
            <template v-for="competitor in selectedCompetitors" v-slot:[`item.ranking_${competitor.domain}`]="{ item }">
                <v-menu
                    id="rankingmenu"
                    style="border-radius: 10px !important"
                    offset-y
                    v-model="menuOpenState[competitor.domain + item.keyword]"
                    rounded
                    @input="menuOpen(item, competitor.domain)"
                    :key="competitor.domain">
                    <template v-slot:activator="{ on }">
                        <!-- Hier wird der Aktivatorinhalt platziert, z.B. ein Button -->
                        <span v-on="on">
                            <div class="pr-3" v-bind="(posData = getRankingPosition(item, competitor.domain))">
                                <v-row class="compranking-wrapper">
                                    <v-chip class="compranking-wrapper" outlined :color="getColor(posData.position)" :class="posData.change == null ? 'qchip ml-auto' : ' ml-auto qchip'">
                                        {{ posData.position }}
                                    </v-chip>
                                    <div class="d-flex my-auto ml-1 px-2" v-if="posData.change != null" style="border: 1px solid rgb(187, 187, 187); border-radius: 14px">
                                        <v-icon :color="posData.change ? (posData.change < 0 ? 'red' : 'green') : ''" small class="my-auto">{{
                                            posData.change ? (posData.change < 0 ? "mdi-chevron-down" : "mdi-chevron-up") : "mdi-chevron-right"
                                        }}</v-icon>
                                        <span :style="posData.change ? (posData.change < 0 ? 'color: red' : 'color: green') : ''" class="rankingchange my-auto">{{ posData.change }}</span>
                                    </div>
                                </v-row>
                            </div>
                        </span>
                    </template>
                    <v-list style="color: rgb(255, 255, 255); border-radius: 10px !important">
                        <!-- Ihr bisheriger Tooltip-Inhalt geht hier hinein -->
                        <div class="px-3 py-1">
                            <div class="mr-1 mb-1 quarolbl">{{ tooltipMenuData.ranking ? "Competitor Ranking:" : "No ranking" }}</div>

                            <div>
                                <div v-if="tooltipMenuData.ranking" style="display: inline-flex">
                                    <div class="fav_wrapper my-auto mr-2">
                                        <img class="fav" :src="'https://s2.googleusercontent.com/s2/favicons?domain=' + tooltipMenuData.ranking.url + '&sz=42'" alt="" />
                                    </div>
                                    <v-chip @click="openURL(tooltipMenuData.ranking.url)"
                                        ><v-icon class="mr-1">mdi-link</v-icon>
                                        {{ tooltipMenuData.ranking.url }}
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SwitchCategoryDialog from "./SwitchCategoryDialog"
    import FilterMenu from "./FilterMenu"
    import DeleteDialog from "../dialogs/DeleteDialog.vue"
    import ConfirmDialog from "../dialogs/ConfirmDialog.vue"
    import { positionColors } from "../helper/global.js"
    export default {
        props: {
            selectedCompetitors: {
                type: Array,
                required: true
            },
            selectedDates: {
                type: Array
            },
            category_id: {
                type: String
            },
            search: {
                type: String
            },
            project_domain: {
                type: String
            },
            exportData: {
                type: Number
            },
            categorized_project: { type: Boolean }
        },
        components: { SwitchCategoryDialog, DeleteDialog, FilterMenu, ConfirmDialog },
        data() {
            return {
                deleteDialog: false,
                confirmDialog: false,
                showSwitchDialog: false,
                selectedRows: [],
                tooltipMenuData: {},
                menuOpenState: {},
                rankings: [],
                count: 0,
                loading: false,
                deleteLoading: false,
                confirmLoading: false,
                sortDesc: true,
                sortBy: "avg_search_volume",
                page: 1,
                itemsPerPage: 25,
                pagination: {},
                sortDomain: null,
                showAllCategories: false,
                filters: []
            }
        },
        computed: {
            positionColors2() {
                return positionColors
            },
            filterFields() {
                let filterFields = [
                    { name: "Keyword", type: "text", key: "keyword" },
                    { name: "Category", type: "text", key: "category_ids" },
                    { name: "Avg Search Volume", type: "number", key: "avg_search_volume" }
                ]
                const avgSearchVolumeIndex = filterFields.findIndex((field) => field.name === "Avg Search Volume")

                // Competitor mit Domain "lutz.de"
                const competitor = this.selectedCompetitors.find((domain) => domain.domain === this.project_domain)

                // Neues Filterfeld für den Competitor
                const competitorField = {
                    domain: competitor.domain,
                    name: `Position - ${competitor.domain}`,
                    key: `rankingsMap.${competitor.domain.split(".").join("_")}.position`,
                    type: "number"
                }

                // Füge das neue Filterfeld nach "Avg Search Volume" ein
                filterFields.splice(avgSearchVolumeIndex + 1, 0, competitorField)

                // Hinzufügen der restlichen Competitors
                this.selectedCompetitors.forEach((domain) => {
                    if (domain.domain !== this.project_domain) {
                        const competitorField = {
                            domain: domain.domain,
                            name: `Position - ${domain.domain}`,
                            key: `rankingsMap.${domain.domain.split(".").join("_")}.position`,
                            type: "number"
                        }
                        filterFields.push(competitorField)
                    }
                })
                if (!this.categorized_project) {
                    //
                    filterFields.splice(1, 1)
                }
                return filterFields
            },
            deleteLabel() {
                let str = ""
                let count = this.selectedRows.length
                return str + count + " Keyword(s) permanently?"
            },
            confirmLabel() {
                let str = "Remove catgories of "
                let count = this.selectedRows.filter((x) => x.category_id).length
                return str + count + " Keyword(s)?"
            },
            footerProps() {
                return {
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true
                }
            },
            headers() {
                let h = [
                    { text: "Keyword", value: "keyword" },
                    { text: "Google Searches (AVG)", value: "avg_search_volume", align: "end", tooltip: "Shows the average google search volume for a keyword" },
                    // { text: "Category", value: "categories", align: "end", sortable: false },
                    // Add a header for each domain
                    ...this.selectedCompetitors.map((domain) => ({
                        text: domain.domain,
                        value: `ranking_${domain.domain}`,
                        align: "end",
                        tooltip: "Shows the position and the position change in googles search results based on the selected dates."
                    }))
                    // {
                    //     text: "",
                    //     value: "actions",
                    //     sortable: false,
                    //     align: "end",
                    //     width: 50
                    // }
                ]
                console.log(this.project_domain)
                let indexOfDomain = h.findIndex((e) => e.text == this.project_domain)
                console.log("indexOfDomain", indexOfDomain)
                if (indexOfDomain > -1) {
                    let targetIndex = 2
                    let removedItem = h.splice(indexOfDomain, 1)[0]
                    h.splice(targetIndex, 0, removedItem)
                }
                return h
            }
        },
        methods: {
            async removeKeywordsCategory() {
                if (!this.selectedRows.length) return
                this.confirmLoading = true
                console.log(this.selectedRows)
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/change/category"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    keywords: this.selectedRows
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.confirmDialog = false
                this.confirmLoading = false
            },
            showCategorySwitchDialog() {
                if (this.selectedRows.length) {
                    this.showSwitchDialog = true
                    return
                }
                let notifidata = { label: "Please select at least one keyword to change the category!", icon: "mdi-alert-circle-outline", color: "#e5a049" }
                this.$emit("notify", notifidata)
            },
            showAllCatsInTable() {
                event.stopPropagation()
                this.showAllCategories = !this.showAllCategories
            },
            openURL(url) {
                window.open(url, "-blank")
            },
            filtersUpdated(filters) {
                console.log(filters)
                this.filters = filters
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            setCategory(item) {
                event.stopPropagation()
                this.$emit("setCategory", item.category_id)
            },
            setCat(item, index) {
                event.stopPropagation()
                this.$emit("setCategory", item.category_id, index)
            },
            catUpdated() {
                this.showSwitchDialog = false
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.selectedRows = []
                let notifidata = { label: "Category successfully changed!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            onRowClick(row) {
                if (this.isSelecting) return
                console.log(row)
                let entryIndex = this.selectedRows.findIndex((e) => e._id == row._id)
                if (entryIndex === -1) {
                    //select
                    this.selectedRows.push(row)
                } else {
                    //unselect
                    this.selectedRows.splice(entryIndex, 1)
                }
            },
            menuOpen(item, competitor) {
                const isMenuOpen = this.menuOpenState[competitor + item.keyword]
                console.log(isMenuOpen)
                if (isMenuOpen) {
                    console.log("Menu opened:", item, competitor)
                    //set tooltipdata
                    this.tooltipMenuData.ranking = item.rankings ? item.rankings.find((e) => e.domain == competitor) : null
                    this.tooltipMenuData.rankingOld = item.rankingsOld ? item.rankingsOld.find((e) => e.domain == competitor) : null
                } else {
                    console.log("Menu closed:", item, competitor)
                }
            },
            /**
             * fetches Keywords and rankings of 2 dates for given selected Competitors
             * @param {*} project_id
             * @param {*} category_id
             * @param {*} skip
             * @param {*} limit
             * @param {*} sort
             */
            async fetchData(tableOptions) {
                try {
                    this.loading = true
                    console.time("fetch rankings")
                    const [dataForDate1, dataForDate2] = await Promise.all([this.fetchDataForDate(this.selectedDates[0], tableOptions), this.fetchDataForDate(this.selectedDates[1], tableOptions)])
                    console.timeEnd("fetch rankings")
                    if (!dataForDate2.rankings.length) {
                        dataForDate2.rankings = JSON.parse(JSON.stringify(dataForDate1.rankings))
                        dataForDate2.totalCount = JSON.parse(JSON.stringify(dataForDate1.totalCount))
                    }
                    dataForDate1.rankings.map((oldRanking) => {
                        let actualRanking = dataForDate2.rankings.find((r) => r.keyword == oldRanking.keyword)
                        if (actualRanking) {
                            actualRanking.rankingsOld = oldRanking.rankings
                        } else {
                        }
                    })

                    this.rankings = dataForDate2.rankings.map((ranking) => {
                        ranking.category_ids.sort()
                        ranking.category_id = ranking.category_ids[ranking.category_ids.length - 1]
                        return ranking
                    })
                    this.count = dataForDate2.totalCount ? dataForDate2.totalCount : 0
                    this.loading = false
                    console.log(this.rankings)
                } catch (error) {
                    console.log(error)
                }
            },
            async fetchDataForDate(date, tableOptions) {
                try {
                    console.log(tableOptions)
                    const domainArray = this.selectedCompetitors.map((c) => c.domain)
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/frontend/keywords"
                    const sort = this.getSortObject(tableOptions)
                    console.log(tableOptions.sortDesc)
                    const post_data = {
                        company_id: localStorage.company_id,
                        company_status: this.$store.state.company_status_monitoring_suite,
                        user_id: localStorage.id,
                        project_id: this.$route.params.id,
                        category_id: this.category_id ? this.category_id : null,
                        domains: domainArray,
                        sortDesc: tableOptions.sortDesc[0] ? -1 : 1,
                        date: date, // Use the current date from the loop
                        search: this.search,
                        start: (tableOptions.page - 1) * tableOptions.itemsPerPage,
                        limit: tableOptions.itemsPerPage,
                        sort: sort,
                        filters: this.filters
                    }

                    if (this.sortDomain) {
                        post_data.sortDomain = this.sortDomain
                    }

                    const response_data = await this.$helpers.axiosPost(url, post_data)
                    return response_data.data
                } catch (error) {
                    console.log(error)
                    throw error
                }
            },
            async deleteKeywords() {
                console.log(this.selectedRows)
                if (!this.selectedRows.length) return
                this.deleteLoading = true
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/delete/keywords"
                const post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    keywords: this.selectedRows,
                    user_id: localStorage.id
                }
                const response_data = await this.$helpers.axiosPost(url, post_data)
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.deleteDialog = false
                this.deleteLoading = false
                this.selectedRows = []
                console.log(response_data.data)
                let notifidata = { label: "The selected keywords have been deleted successfully!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            // builds sort object for backend data request
            getSortObject(tableOptions) {
                this.sortDomain = null
                let sort = { avg_search_volume: -1 }
                if (Array.isArray(tableOptions.sortBy) && tableOptions.sortBy.length) {
                    if (tableOptions.sortBy[0].startsWith("ranking")) {
                        this.sortDomain = tableOptions.sortBy[0].substring(8)
                    } else {
                        sort[tableOptions.sortBy[0]] = tableOptions.sortDesc[0] ? -1 : 1
                    }
                }
                return sort
            },
            /**
             * returns pos fpr competitor table
             * @param {*} item
             * @param {*} domain
             */
            getRankingPosition(item, domain) {
                const ranking = item.rankings.find((r) => r.domain === domain)
                console.log(item)
                const oldRanking = item.rankingsOld ? item.rankingsOld.find((r) => r.domain === domain) : null
                const change = oldRanking && ranking ? ranking.position - oldRanking.position : null
                return { position: ranking ? ranking.position : "-", change: change * -1 } // *-1 : 16 --> 20 = +4 sollte aber minuse 4 ergeben daher *-1
            },
            getColor(position) {
                let colorIndex = Math.ceil(position / 10) - 1
                let color = positionColors[colorIndex] ? positionColors[colorIndex] : positionColors[positionColors.length - 1]
                return color
            }
        },
        watch: {
            selectedCompetitors: {
                handler() {
                    // Fetch data when the domains prop changes
                    this.fetchData({
                        sortDesc: this.sortDesc,
                        sortBy: this.sortBy,
                        page: this.page,
                        itemsPerPage: this.itemsPerPage
                    })
                },
                immediate: false // Fetch data initially when the component is created
            },
            async exportData() {
                console.log("download triggered")
                console.log(this.rankings)
                console.log(this.selectedDates)
                let fields = this.headers.map((header) => header.text)
                let rows = this.rankings.map((ranking) => {
                    let row = {}
                    this.headers.map((header) => {
                        if (header.value.substring(0, 8) == "ranking_") {
                            let compRanking = ranking.rankings.find((r) => r.domain == header.text)
                            row[header.text] = compRanking ? compRanking.position : 0
                            // row[header.text + " - " + this.selectedDates[0]] = ranking.rankingsOld.find((r) => r.domain == header.text)
                        } else {
                            row[header.text] = ranking[header.value]
                        }
                    })
                    return row
                })
                console.log(rows, fields)

                let post_data = {
                    rows: rows,
                    fields: fields
                }
                if (this.selectedDates[1]) {
                    post_data.fileTitle = "Rankings_" + this.selectedDates[1].substring(0, 10)
                } else {
                    post_data.fileTitle = "Rankings_" + this.selectedDates[0].substring(0, 10)
                }
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/export/csv"
                let response_data = await this.$helpers.axiosPost(url, post_data)
                window.location =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") +
                    "/" +
                    response_data.data
            },
            selectedDates() {
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            category_id() {
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            search() {
                // Fetch data when the search query changes
                this.page = 1 // Reset the page to 1 when searching
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            }
        }
    }
</script>

<style>
    #rankingstable th {
        white-space: nowrap !important;
    }
    .rtd {
        font-size: 0.98rem !important;
        white-space: nowrap;
    }
    #rankingstable .qchip {
        background-color: rgb(245, 245, 245) !important;
        border-width: 1px;
    }
    #monitoringCompTable .qchip {
        background-color: rgb(245, 245, 245) !important;
        border-width: 1px;
    }
    #trendsTable .qchip {
        background-color: rgb(245, 245, 245) !important;
        border-width: 1px;
    }
    .theme--dark #rankingstable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .theme--dark #monitoringCompTable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .theme--dark #trendsTable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .rankingchange {
        color: grey;
        font-size: 12px;
        /* padding-top: 2px; */
    }
    .compranking-wrapper:hover {
        cursor: pointer;
    }
    #rankingstable #rankinglink:hover {
        color: red !important;
    }
    #rankingstable #rankingslink {
        font-weight: 100;
        color: white !important;
    }
    #rankingstable table > tbody > tr:hover {
        cursor: pointer;
    }
    #trendsTable .theme--light.v-data-table tbody tr.v-data-table__selected {
        background: #8dc4b936 !important;
    }
    /* #rankingstable table > tbody > tr > td:nth-child(1),
    #rankingstable table > tbody > tr > th:nth-child(1) {
        background: var(--v-keywordcol-base) !important;
    }
    #rankingstable table > tbody > tr > td:nth-child(2),
    #rankingstable table > tbody > tr > th:nth-child(2) {
        background: var(--v-keywordcol-base) !important;
    } */
    #rankingstable table > tbody > tr > td:nth-child(3),
    #rankingstable table > thead > tr > th:nth-child(3) {
        /* background: #edeff1 !important; */
        border-left: 2px solid #edeff1;
        border-right: 2px solid #edeff1;
    }
    .theme--dark #rankingstable table > tbody > tr > td:nth-child(3),
    .theme--dark #rankingstable table > thead > tr > th:nth-child(3) {
        /* background: #edeff1 !important; */
        border-left: 2px solid #000000;
        border-right: 2px solid #000000;
    }
    #inspire > div.v-menu__content.theme--light.rounded.menuable__content__active {
        border-radius: 10px !important;
    }
</style>
